import {Component, Inject} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";
import {MatTooltipModule} from '@angular/material/tooltip';
import {RouterLinkActive} from '@angular/router';
import {CommonModule} from '@angular/common';
import { SessionProviderService } from 'src/app/services/sp-authentication/session-provider.service';
import { Subscription } from 'src/app/models/subscription';

@Component({
  standalone: true,
  templateUrl: './sp-modal-crawl-confirmation.component.html',
  imports: [
    CommonModule,
    MatTooltipModule,
    RouterLinkActive
  ]
})
export class SpModalCrawlConfirmationComponent {
  balanceAfter: number = 0;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: {creditCount: number},
    public dialogRef: MatDialogRef<SpModalCrawlConfirmationComponent>,
    private sessionProvider: SessionProviderService
  ) {
    // One figure, taken off the whole balance. Subtracting from the two balances
    // separately also got the arithmetic wrong whenever a spend spilled from the monthly
    // one into the extra one: the monthly part clamped at zero while the extra part was
    // left untouched, so the modal under-reported the spend.
    const subscription = this.sessionProvider.activeSession.user.company.subscription;
    this.balanceAfter = Math.max(Subscription.totalCredits(subscription) - data.creditCount, 0);
  }

  cancel(): void {
    this.dialogRef.close(false);
  }

  confirm(){
    this.dialogRef.close(true)
  }
}
